module.exports = __webpack_public_path__ + "img/横版烫金.91d06155.png";